<div *ngFor="let p of ownPortfolios" style="clear: both">
  <h3>{{ p.name }}</h3>
  <hr-sales-report [portfolioId]="p.portfolioId"></hr-sales-report>
</div>
